const defaultValues = {
  isValidationListVisible: false,
  hasToAnimateButton: false,
  templateValidationsNotifications: [],
};
Object.freeze(defaultValues);

export default defaultValues;
